var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { mergeProps, useFocusRing } from 'react-aria';
import { useId } from '../hooks';
import { Text } from '../text';
import Checkmark from './checkmark';
import { inputStaticStyle, labelStaticStyle, wrapperStyle } from './styles';
function CheckboxInternal(_a, ref) {
    var { 'aria-label': ariaLabel, checked, children, defaultChecked = false, disabled = false, error = false, inverted = false, isIndeterminate = false, size = 'medium' } = _a, restProps = __rest(_a, ['aria-label', "checked", "children", "defaultChecked", "disabled", "error", "inverted", "isIndeterminate", "size"]);
    const { focusProps, isFocusVisible } = useFocusRing();
    const checkboxRef = useRef(null);
    const [internalChecked, setInternalChecked] = useState(defaultChecked);
    const checkboxId = `checkbox-${useId()}`;
    const hasChildren = children != null;
    useImperativeHandle(ref, () => checkboxRef.current);
    function handleChange(event) {
        setInternalChecked(event.target.checked);
    }
    // Handle setting the IDL property, as it's not available as a normal attribute
    useEffect(() => {
        if (checkboxRef.current != null) {
            checkboxRef.current.indeterminate = isIndeterminate;
        }
    }, [isIndeterminate]);
    return (_jsxs("div", Object.assign({ css: wrapperStyle({ disabled, inverted }) }, { children: [_jsx("input", Object.assign({ ref: checkboxRef }, (hasChildren && { id: checkboxId }), { "aria-invalid": error, "aria-label": ariaLabel, css: inputStaticStyle, disabled: disabled, type: "checkbox" }, mergeProps(focusProps, restProps, Object.assign({}, (checked == null
                ? { defaultChecked, onChange: handleChange }
                : { checked }))))), _jsx(Checkmark, Object.assign({}, {
                checked: checked !== null && checked !== void 0 ? checked : internalChecked,
                disabled,
                error,
                isFocusVisible,
                isIndeterminate,
            })), hasChildren && (_jsx(Text, Object.assign({ as: "label", css: labelStaticStyle, htmlFor: checkboxId, size: size }, { children: children })))] })));
}
export default CheckboxInternal;
